import {
  Outlet,
  Link,
  useLoaderData,
  NavLink,
  useLocation,
} from "react-router-dom";
import { Resizable } from "re-resizable";
import * as API from "../services/pacientes";

import Navigation from "./Navigation";

import { ReactComponent as Logo } from "../img/logo.svg";

import packageJson from "../../package.json";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getPacienteByID(params.pacienteId);
}

export function ConfiguracionContent(props) {
  const location = useLocation();
  return (
    <>
      <Resizable
        id="sidebar"
        defaultSize={{
          width: 315,
        }}
        minHeight="100vh"
        maxHeight="100vh"
      >
        <div className="logo">
          <Logo />
        </div>
        {/* other code */}

        <nav>
          <ul>
            <li>
              <NavLink to={`pacientes`}>Pacientes</NavLink>
            </li>
            <li>
              <NavLink to={`especialistas`}>Especialistas</NavLink>
            </li>
            {/* <li><NavLink to={`listados`}>Listados</NavLink></li> */}
            <li>
              <NavLink to={`listado-completo`}>Listados</NavLink>
            </li>
            {/* <li><NavLink to={`listado-tratamientos`}>Listado Tratamientos</NavLink></li>
            <li><NavLink to={`listado-pacientes`}>Listado Pacientes</NavLink></li> */}
          </ul>
        </nav>
      </Resizable>
      <main id="main">
        <Navigation {...props} currentUrl={location.pathname} />
        <div id="detail">
          <Outlet />
          <p
            className="has-text-right is-size-7"
            style={{ position: "absolute", bottom: "10px", right: "10px" }}
          >
            Versión de la aplicación: {packageJson.version}
          </p>
        </div>
      </main>
    </>
  );
}
